
import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { storeUser } from "../../../reducers/app.reducer";
import FormInputTextComponent from "../../atoms/form-input/form-input-text/form-input-text.component";
import { formValidate } from "../../../utils/validation.utils";
import AlertComponent from "../../atoms/alert/alert.component";
import { saveCustomerAPI } from "../../../service/customer.service";

const validations = [
  {
    type: "REQUIRED",
    name: "firstname",
    message: "Please enter the firstname",
  },

  {
    type: "REQUIRED",
    name: "lastname",
    message: "Please enter the lastname",
  },

  {
    type: "REQUIRED",
    name: "company_name",
    message: "Please enter the company name",
  },

  {
    type: "REQUIRED",
    name: "mobile",
    message: "Please enter the mobile",
  },

  {
    type: "REQUIRED",
    name: "designation",
    message: "Please enter the designation",
  },
];

const PersonalInfoComponent = ({ user }) => {
  console.log({ user });
  const [values, setValues] = useState(user);
  const [errors, setErrors] = useState({});
  const [alert, setAlert] = useState({ show: false });
  const dispatch = useDispatch();

  const handleChange = (name, value) => {
    setValues({ ...values, [name]: value });
  };

  const handleSubmit = async (e = null) => {
    console.log({ e });
    if (e) {
      e.preventDefault();
    }

    setErrors({});

    const errorResp = formValidate({ validations, values });
  

    if (errorResp.status) {
      setErrors(errorResp.errors);
      return;
    }

    console.log({ errorResp });

    const payload = {
      firstname: values?.firstname,
      lastname: values?.lastname,
      company_name: values?.company_name,
      mobile: values?.mobile,
      designation: values?.designation,
    };

    const updateResp = await saveCustomerAPI(payload);

    console.log({ updateResp });

    if (updateResp.status) {
      dispatch(storeUser({ ...user, ...payload }));
      setAlert({
        ...alert,
        show: true,
        type: "success",
        message: "Personal info updated successfully",
      });
    } else {
      setAlert({
        ...alert,
        show: true,
        type: "danger",
        message: updateResp.message,
      });
    }
  };

  const handleAlertClose = () => {
    setAlert({ ...alert, show: false });
  };
  console.log({ values });

  return (
    <>
      <form onSubmit={handleSubmit}>
        <div class="row">
          <div class="col-md-6">
            <div class="mb-3">
              <FormInputTextComponent
                type="text"
                id={"name"}
                name={"name"}
                // label={"Firstname"}
                isVertical
                value={values?.firstname}
                placeholder={"First Name"}
                error={errors.firstname}
                onChange={(val) => handleChange("firstname", val)}
              />
            </div>
          </div>
          <div class="col-md-6">
            <div class="mb-3">
              <FormInputTextComponent
                type="text"
                id={"lastname"}
                name={"lastname"}
                // label={"Lastname"}
                isVertical
                value={values?.lastname}
                placeholder={"Last Name"}
                error={errors.lastname}
                onChange={(val) => handleChange("lastname", val)}
              />
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-4">
            <div class="mb-3">
              <FormInputTextComponent
                type="number"
                id={"mobile"}
                name={"mobile"}
                // label={"Mobile"}
                isVertical
                value={values?.mobile}
                placeholder={"Mobile"}
                error={errors.mobile}
                onChange={(val) => handleChange("mobile", val)}
              />
            </div>
          </div>
          <div class="col-md-4">
            <div class="mb-3">
              <FormInputTextComponent
                type="text"
                id={"designation"}
                name={"designation"}
                // label={"Designation"}
                isVertical
                value={values?.designation}
                placeholder={"Designation"}
                error={errors.designation}
                onChange={(val) => handleChange("designation", val)}
              />
            </div>
          </div>
          <div class="col-md-4">
            <div class="mb-3">
              <FormInputTextComponent
                type="text"
                id={"email"}
                name={"email"}
                // label={"Email"}
                isVertical
                value={values?.email}
                placeholder={"Email"}
                error={errors.email}
                isDisabled
                onChange={(val) => handleChange("email", val)}
              />
            </div>
          </div>
        </div>
        <div class="mb-3">
          <FormInputTextComponent
            type="text"
            id={"company_name"}
            name={"company_name"}
            // label={"Company"}
            isVertical
            value={values?.company_name}
            placeholder={"Company Name"}
            error={errors.company_name}
            onChange={(val) => handleChange("company_name", val)}
          />
        </div>

        {alert.show && (
          <div className="mb-3">
            <AlertComponent
              type={alert.type}
              message={alert.message}
              onClose={handleAlertClose}
            />
          </div>
        )}

        <div className="d-flex justify-content-center mt-3">
  <button
    onClick={handleSubmit}
    className="btn btn-primary"
  >
    Save Personal Details
  </button>
</div>
      </form>
    </>
  );
};

export default PersonalInfoComponent;
